<template>
    <nav class="menu">
        <!--		<router-link-->
        <!--			:to="{ name: 'Admin - Contratos' }"-->
        <!--			class="menu-item"-->
        <!--			v-if="contratosVisible"-->
        <!--		>-->
        <!--			<span class="menu-item-icon">-->
        <!--				<i class="fas fa-file-contract"></i>-->
        <!--			</span>-->
        <!--			Contratos-->
        <!--		</router-link>-->

        <router-link
            v-if="campañasVisible"
            :to="{ name: 'Admin - Elecciones' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="fas fa-vote-yea"></i>
            </span>
            Campañas
        </router-link>

        <router-link
            v-if="votosEmitidosVisible"
            :to="{ name: 'votos-emitidos' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="far fa-file-archive"></i>
            </span>
            Votos Emitidos
        </router-link>

        <router-link
            v-if="padronVisible"
            :to="{ name: 'padron' }"
            class="menu-item menu-item-bottom"
        >
            <span class="menu-item-icon">
                <i class="fas fa-users"></i>
            </span>
            Padrón Activo
        </router-link>
        
        <router-link
            v-if="reportsVisible"
            :class="{ 'menu-item-bottom': !padronVisible }"
            :to="{ name: 'Admin -reportes' }"
            class="menu-item menu-item "
        >
            <span class="menu-item-icon">
                <i class="fas fa-chart-area"></i>
            </span>
            Reportes
        </router-link>
        <router-link
            v-if="dispositivosVisible"
            :class="{ 'menu-item-bottom': !padronVisible }"
            :to="{ name: 'dispositivos' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="fas fa-mobile"></i>
            </span>
            Dispositivos
        </router-link>
        <router-link
            v-if="votosDispositivoVisible"
            :class="{
                'menu-item-bottom': !padronVisible && !dispositivosVisible,
            }"
            :to="{ name: 'voto-por-dispositivo' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="fas fa-file-invoice"></i>
            </span>
            Votos por dispositivo
        </router-link>
        <router-link
            v-if="tablesVisible"
            :class="{
                'menu-item-bottom':
                    !padronVisible &&
                    !votosDispositivoVisible &&
                    !dispositivosVisible,
            }"
            :to="{ name: 'Mesas' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <v-img
                    :src="require('../../assets/icn_voto_mesas_white.svg')"
                    max-height="14px"
                    max-width="19.99px"
                ></v-img>
            </span>
            Mesas
        </router-link>
        <router-link
            v-if="prepVisible"
            :class="{
                'menu-item-bottom':
                    !padronVisible &&
                    !votosDispositivoVisible &&
                    !dispositivosVisible &&
                    !tablesVisible,
            }"
            :to="{ name: 'prep' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="far fa-chart-bar"></i>
            </span>
            PREP
        </router-link>

        <router-link
            :class="{
                'menu-item-bottom':
                    !padronVisible &&
                    !votosDispositivoVisible &&
                    !dispositivosVisible &&
                    !tablesVisible &&
                    !prepVisible,
            }"
            :to="{ name: 'planillas' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="fas fa-file-alt"></i>
            </span>
            Planillas
        </router-link>
        <router-link
            v-if="prepVisible"
            :class="{
                'menu-item-bottom':
                    !padronVisible &&
                    !votosDispositivoVisible &&
                    !dispositivosVisible &&
                    !tablesVisible,
            }"
            :to="{ name: 'resultados' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="fas fa-chart-pie"></i>
            </span>
            Resultados
        </router-link>
        <router-link
            v-if="prepVisible"
            :class="{
                'menu-item-bottom':
                    !padronVisible &&
                    !votosDispositivoVisible &&
                    !dispositivosVisible &&
                    !tablesVisible,
            }"
            :to="{ name: 'preview' }"
            class="menu-item"
        >
            <span class="menu-item-icon">
                <i class="fas fa-chart-bar"></i>
            </span>
            Votos vs Votantes
        </router-link>
        <div
            :class="{
                'menu-item-bottom':
                    !padronVisible &&
                    !votosDispositivoVisible &&
                    !dispositivosVisible &&
                    !tablesVisible &&
                    !prepVisible &&
                    !planillasVisible,
            }"
            class="menu-item"
            @click="logout"
        >
            <span class="menu-item-icon">
                <i class="fas fa-sign-out-alt"></i>
            </span>
            Cerrar sesión
        </div>
    </nav>
</template>

<script>
import _ from 'lodash';

import {
    ADMIN_TYPE,
    HELPDESK_TYPE,
    SECRETARIA_TYPE,
} from '@/helpers/roleTypes';

export default {
    methods: {
        logout() {
            this.$store.commit('SET_TOKEN', null);
            this.$router.push({ name: 'Login' });
        },
    },
    computed: {
        mode() {
            return _.get(this, '$store.getters.user.mode');
        },
        contratosVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
        reportsVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        campañasVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        estacionesVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        votosVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        votosEmitidosVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
        academicosVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        alumnosVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        padronVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        dispositivosVisible() {
            return [ADMIN_TYPE].includes(this.mode);
        },
        votosDispositivoVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        tablesVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        prepVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        planillasVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.menu {
    display: flex;
    flex-direction: column;
    background-color: $votex-primary;
    height: 100%;
    color: white !important;

    a {
        color: white;
        text-decoration: none;
    }
}

.menu-item {
    padding: 10px;
    width: 100%;
    display: flex;
    height: 40px;
    align-items: center;
    border-bottom: 1px white solid;

    &:hover {
        cursor: pointer;
        background-color: lighten($votex-primary, 25%);
        color: white !important;
    }

    &-icon {
        margin-right: 5px;
    }
}

.menu-item-bottom {
    margin-top: auto;
}

.active {
    background-color: #dadada;
    color: black !important;
}
</style>
